import React, { useState, useRef } from 'react'
import { Input, Form, Button } from 'antd'

import {EyeIcon, ClosedEyeIcon} from '../../../modules/CustomIcons'
import './password.scss'
import '../InputField/float.scss'
import { useTranslation } from 'react-i18next'

const PasswordField = (props: any) => {
  const {t} = useTranslation()
  const [focus, setFocus] = useState(false)
  const { label } = props
  const [passwordValue, setPassword] = useState(props.passwordValue)
  
  const [visiblePassword, setVisible] = useState(false)
  const input_name=props.name || '';
  // const passwordInputref = useRef<any>(null)

  // function handlePasswordChange(e: any) {
  //   localStorage.setItem('password', passwordValue)
  //   setPassword(e.target.value)
  // }
  const [isFocused, setIsFocused] = useState("")
  const handlePasswordChange = (e:any) => {
    setIsFocused(e.target.value)
    if (props.form){
      props.form.setFieldsValue(
          {
            [input_name]: e.target.value
          }
      );
    }

    if (props.handlePasswordChange){
      props.handlePasswordChange(e);
    }
  }

  const onKeyUp = (e : any) => {
    if (props.onKeyUp){
      props.onKeyUp(e)
    }
  }

  function handleShowPasswordMouseDown() {
    setVisible(true)
    setFocus(true)
  }
  function handleShowPassword() {
    setVisible(false)
    setFocus(false)
  }
  const labelClass = focus || props.passwordValue || isFocused ?  'label label-float' : 'label';
  let validate_message=props.message || '';

  if (props.required && !props.message){
    validate_message=t("newTransfer.requiredField");
  }

  if (props.showMessage){
    validate_message='';
  }

  return (
    <>
      <Form.Item
          label={props.labelItem}
          labelCol={props.labelCol}
          wrapperCol={props.wrapperCol}
          className={props.className}
          name={input_name}
          rules={[{ required: props.required || false, message : validate_message }]}
      >
        <div
          className="float-label"
          onBlur={() => setFocus(false)}
          onFocus={() => setFocus(true)}
        >
          <Input.Group className='password-input'>
            <Input
            id={input_name}
              onChange={handlePasswordChange}
              onKeyUp={onKeyUp}
              type={!visiblePassword ? 'password' : 'input'}
              className={`${!visiblePassword ? 'password-input-secured' : ''} ${props.className}`}
              readOnly={props.readOnly || false}
              name={input_name}
              ref={props.inputRef}
              value={props.passwordValue}
              // ref={passwordInputref}
              defaultValue={props.defaultValue}
              minLength={props.minLength || ''}
              maxLength={props.maxLength || ''}
              placeholder={props.placeholder}
              allowClear={props.allowClear || false}
              prefix={props.prefix || false}
              autoComplete={props.autoComplete || "off"}
              /*suffix={props.suffix || false}*/
            />
            <label htmlFor={input_name} className={labelClass}>{label}</label>
            {
                props.suffix && <span className={'ant-input-suffix'} style={{marginRight: 11}}>{props.suffix}</span>
            }
            <Button
              className='password-input__btn'
              onMouseDown={handleShowPasswordMouseDown}
              onMouseUp={handleShowPassword}
              onMouseOut={handleShowPassword}
              onTouchStart={handleShowPasswordMouseDown}
              onTouchEnd={handleShowPassword}
              ghost={true}
              icon={!visiblePassword ? <ClosedEyeIcon/> : <EyeIcon/>}
              htmlType='button'
              type='primary'
            >
            </Button>
            
          </Input.Group>
        </div>

        {
          props.showMessage && <span className={'form_error_span'} >{props.message}</span>
        }
      </Form.Item>
    </>
  )
}

export default PasswordField
